export const mockProductsData = {
  "products": [
    {
      "_id": "68302128d692df73b3a4d36c",
      "name": "American Sheer Curtain",
      "description": "<p>American sheer curtains offer the perfect solution for light control and privacy while adding a refined touch to your interiors. With their airy, lightweight fabric, these curtains allow natural light to filter through, creating a warm and open ambiance. Ideal for both modern and classic home designs, these versatile sheer curtains effortlessly complement any decor style.</p>",
      "sub_content": "Privacy with a Soft, Elegant Glow",
      "specification": [
        "Enhance privacy without compromising natural light",
        "Stylish, elegant, and functional for contemporary and traditional spaces"
      ],
      "category": "CURTAINS",
      "price_per_sqft": 80,
      "offer_percentage": 12,
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/American-Sheer-curtain.jpg",
          "_id": "68302128d692df73b3a4d36c"
        }
      ],
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 203,
          "offer_percentage": 12,
          "_id": "6965f62b95c23012f6fec4e3"
        },
        {
          "width": 100,
          "height": 200,
          "price_per_sqft": 120,
          "offer_percentage": 10,
          "_id": "6965f62b95c23012f6fec4e4"
        },
        {
          "width": 200,
          "height": 200,
          "price_per_sqft": 150,
          "offer_percentage": 8,
          "_id": "6965f62b95c23012f6fec4e5"
        },
        {
          "width": 150,
          "height": 300,
          "price_per_sqft": 1200,
          "offer_percentage": 9,
          "_id": "6965f62b95c23012f6fec4e6"
        },
        {
          "width": 200,
          "height": 158,
          "price_per_sqft": 140,
          "offer_percentage": 13,
          "_id": "6965f62b95c23012f6fec4e7"
        }
      ],
      "createdAt": "2025-05-23T07:18:00.265Z",
      "updatedAt": "2026-01-13T07:37:15.270Z",
      "__v": 0
    },
    {
      "_id": "68302219d692df73b3a4d371",
      "name": "American Blackout Curtain",
      "description": "<p>American blackout curtains are the ultimate solution for complete darkness and privacy. Ideal for restful sleep or movie nights, they block out all light while improving energy efficiency by keeping rooms cooler in summer and warmer in winter</p>",
      "sub_content": "Block the Light, Embrace Comfort",
      "specification": [
        "Full light-blocking for privacy and comfort",
        "Energy-efficient and noise-reducing design"
      ],
      "category": "CURTAINS",
      "price_per_sqft": 120,
      "offer_percentage": 10,
      "is_emi_available": false,
      "emi_period": null,
      "is_active": true,
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/American-Blackout-Curtain.jpeg",
          "_id": "68302219d692df73b3a4d371"
        }
      ],
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 520,
          "offer_percentage": 10,
          "_id": "6965f60395c23012f6fec4b8"
        }
      ],
      "createdAt": "2025-05-23T07:22:01.415Z",
      "updatedAt": "2026-01-13T07:36:35.685Z",
      "__v": 0
    },
    {
      "_id": "68304965326ae7a21769a5d7",
      "name": "American Blackout & Sheer Curtain",
      "description": "<p>Experience the ideal balance of light and privacy with American blackout and sheer curtains. Let natural light filter through the sheers during the day, then block out light and noise at night with the blackout layer. These curtains ensure complete privacy, restful sleep, and a stylish upgrade for any room. Perfect for bedrooms, living rooms, and more.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/American-Blackout&Sheer-Curtain.jpeg",
          "_id": "68304965326ae7a21769a5d7"
        }
      ],
      "sub_content": "Seamless Light and Privacy Control Anytime",
      "specification": [
        "Dual-layer curtains for light and noise control",
        "Sleek, functional, and adaptable to any room"
      ],
      "price_per_sqft": 160,
      "offer_percentage": 5,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 1420,
          "offer_percentage": 20,
          "_id": "6965f5d695c23012f6fec48d"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:09:41.124Z",
      "updatedAt": "2026-01-13T07:35:50.704Z",
      "__v": 0,
      "category": "CURTAINS"
    },
    {
      "_id": "683049d7a222bf615f5398c7",
      "name": "Wave Sheer Curtain",
      "description": "<p>Wave sheer curtains add a soft, flowing elegance to your home, combining natural light control with privacy. Their modern design creates a relaxed, airy ambiance, perfect for living rooms, bedrooms, or any space. These sophisticated curtains complement any decor with their timeless charm.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Wave-Sheer-curtain.jpg",
          "_id": "683049d7a222bf615f5398c7"
        }
      ],
      "sub_content": "Graceful Waves, Effortless Elegance",
      "specification": [
        "Stylish, airy design for light and privacy",
        "Perfect for modern and classic interiors"
      ],
      "price_per_sqft": 110,
      "offer_percentage": 5,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 150,
          "offer_percentage": 12,
          "_id": "6965f5b595c23012f6fec462"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:11:35.822Z",
      "updatedAt": "2026-01-13T07:35:17.343Z",
      "__v": 0,
      "category": "CURTAINS"
    },
    {
      "_id": "68304a18a222bf615f5398ce",
      "name": "Wave Blackout Curtain",
      "description": "<p>Wave blackout curtains combine elegant style with complete darkness. The chic wave design adds a modern touch, while the blackout layer ensures total privacy and energy efficiency, creating the perfect atmosphere for relaxation or focus.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Wave-Blackout-Curtain.jpeg",
          "_id": "68304a18a222bf615f5398ce"
        }
      ],
      "sub_content": "Wave Elegance, Absolute Darkness",
      "specification": [
        "Elegant wave design with blackout functionality",
        "Enhances room temperature control"
      ],
      "price_per_sqft": 140,
      "offer_percentage": 5,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 500,
          "offer_percentage": 12,
          "_id": "6965f56295c23012f6fec3f5"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:12:40.431Z",
      "updatedAt": "2026-01-13T07:33:54.340Z",
      "__v": 0,
      "category": "CURTAINS"
    },
    {
      "_id": "68304a64a222bf615f5398d5",
      "name": "Wave Blackout & Sheer Curtain",
      "description": "<p>Achieve the perfect balance of light and privacy with wave blackout &amp; sheer curtains. The sheer layer lets in natural light, while the blackout layer provides complete privacy and darkness when needed. Their stylish wave design adds sophistication to any room.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Wave-Blackout&Sheer-Curtain.jpg",
          "_id": "68304a64a222bf615f5398d5"
        }
      ],
      "sub_content": "Sculpted Waves, Seamless Light Control",
      "specification": [
        "Dual-layer curtains for light and privacy",
        "Stylish wave design for any decor"
      ],
      "price_per_sqft": 180,
      "offer_percentage": 25,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 42,
          "offer_percentage": 10,
          "_id": "6962319dd2178c2d96d58ff2"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:13:56.552Z",
      "updatedAt": "2026-01-10T11:01:49.892Z",
      "__v": 0,
      "category": "CURTAINS"
    },
    {
      "_id": "68304aaf326ae7a21769a5ed",
      "name": "Roller Blinds",
      "description": "<p>Roller blinds provide sleek, modern window treatments that blend form and function. Easy to operate and chic in design, they deliver excellent privacy and light control while adding a minimalist touch to any room. Practical and stylish, they fit seamlessly into your home.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Rollar-blinds.jpg",
          "_id": "68304aaf326ae7a21769a5ed"
        }
      ],
      "sub_content": "Effortless Style, Perfect Privacy",
      "specification": [
        "Sleek and modern minimalist style",
        "Easy-to-use blinds for privacy and light control"
      ],
      "price_per_sqft": 95,
      "offer_percentage": 15,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 31,
          "offer_percentage": 3,
          "_id": "696231b8d2178c2d96d5901d"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:15:11.876Z",
      "updatedAt": "2026-01-10T11:02:16.629Z",
      "__v": 0,
      "category": "BLINDS"
    },
    {
      "_id": "68304af1a222bf615f5398ea",
      "name": "Roman Blinds",
      "description": "<p>Enhance your space with the luxurious appeal of Roman blinds. Perfect for adding warmth and sophistication, these blinds offer excellent light control and privacy. Whether you're creating a cozy retreat or a stylish statement, Roman blinds combine beauty and functionality seamlessly.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Roman-Blinds.jpeg",
          "_id": "68304af1a222bf615f5398ea"
        }
      ],
      "sub_content": "Classic Charm, Timeless Elegance",
      "specification": [
        "Elegant design for a cozy or stylish space",
        "Exceptional light and privacy control"
      ],
      "price_per_sqft": 120,
      "offer_percentage": 10,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 52,
          "offer_percentage": 3,
          "_id": "696231e2d2178c2d96d5906f"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:16:17.373Z",
      "updatedAt": "2026-01-10T11:02:58.936Z",
      "__v": 0,
      "category": "BLINDS"
    },
    {
      "_id": "68304b37a222bf615f5398f1",
      "name": "Venetien Blinds",
      "description": "<p>Venetian blinds are the epitome of functionality and style. Their adjustable slats allow precise control over light and privacy, while their sleek, timeless design adds sophistication to any space. Ideal for both modern and classic interiors.</p>",
      "logo_image": [],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Venetien-Blinds.jpeg",
          "_id": "68304b37a222bf615f5398f1"
        }
      ],
      "sub_content": "Timeless Style, Ultimate Control",
      "specification": [
        "Adjustable slats for light and privacy",
        "Sophisticated design for all interiors"
      ],
      "price_per_sqft": 90,
      "offer_percentage": 20,
      "standard_items": [
        {
          "width": 200,
          "height": 300,
          "price_per_sqft": 12,
          "offer_percentage": 2,
          "_id": "696231f7d2178c2d96d5909a"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:17:27.677Z",
      "updatedAt": "2026-01-10T11:03:19.570Z",
      "__v": 0,
      "category": "BLINDS"
    },
    {
      "_id": "68304b7ca222bf615f5398fd",
      "name": "Vertical Blinds",
      "description": "<p>Vertical blinds offer a stylish solution for wide windows or sliding doors. With easy-to-adjust slats, they allow you to control light and privacy effortlessly while maintaining a clean, modern look. Perfect for both residential and commercial spaces.</p>",
      "logo_image": [
        {
          "public_id": "zeal_uploads/wvflgsnmjnuctpx2o5rc",
          "url": "https://res.cloudinary.com/dnzdarqjr/image/upload/v1768043017/zeal_uploads/wvflgsnmjnuctpx2o5rc.jpg",
          "_id": "6962322ed2178c2d96d590d0"
        }
      ],
      "banner_image": [
        {
          "url": "/assets/images/Estimate/Vertical-Blinds.jpg",
          "_id": "68304b7ca222bf615f5398fd"
        }
      ],
      "sub_content": "Maximize Light, Minimize Clutter",
      "specification": [
        "Smart, space-saving design",
        "Ideal for wide windows and sliding doors"
      ],
      "price_per_sqft": 90,
      "offer_percentage": 10,
      "standard_items": [
        {
          "width": 100,
          "height": 100,
          "price_per_sqft": 80,
          "offer_percentage": 10,
          "_id": "6962322ed2178c2d96d590cb"
        },
        {
          "width": 250,
          "height": 350,
          "price_per_sqft": 240,
          "offer_percentage": 10,
          "_id": "6962322ed2178c2d96d590cc"
        }
      ],
      "is_emi_available": false,
      "emi_period": 0,
      "is_active": true,
      "createdAt": "2025-05-23T10:18:36.687Z",
      "updatedAt": "2026-01-10T11:04:14.866Z",
      "__v": 0,
      "category": "BLINDS"
    }
  ],
  "total": 10,
  "page": 1,
  "count": {
    "allcount": 10,
    "active": 10,
    "inactive": 0
  }
};
export default mockProductsData;
